import { useMemo, useEffect, useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import { Col, Row, Tabs } from "antd";
import {
  AreaChartOutlined,
  ContactsOutlined,
  DashboardOutlined,
  EditOutlined,
  FilePdfOutlined,
  FormOutlined,
  HeartOutlined,
  LikeOutlined,
  MessageOutlined,
  NotificationOutlined,
  PicLeftOutlined,
  ShopOutlined,
  UserOutlined,
} from "@ant-design/icons";
import ReportIndex from "./Report/ReportIndex";
import MLSIndex from "./MLS/MLSIndex";
import AlarmIndex from "./Alarm/AlarmIndex";
import NotificationIndex from "./Notification/NotificationIndex";
import MessageIndex from "./Message/MessageIndex";
import ProfileIndex from "./Profile/ProfileIndex";
import FavoriteIndex from "./Favorite/FavoriteIndex";
import InvoiceIndex from "./Invoice/Invoice";
import StepsIndex from "./Ad/Components/StepsIndex";
import StoreIndex from "./Store/StoreIndex";
import UserManagementIndex from "./User/UserIndex";
import InvitesIndex from "./Invite/InviteIndex";
import PortfolioIndex from "./MLS/Components/Portfolio/PortfolioIndex";
import { handleResetAllAdvertState } from "./Ad/ClientSideStates";
import ContractIndex from "apps/CustomerPanel/Contract/ContractIndex";
import myAdvertEndPoints from "apps/CustomerPanel/MLS/Components/Portfolio/EndPoints"
import inviteEndPoints from "apps/CustomerPanel/Invite/EndPoints"
import messageEndPoints from "apps/CustomerPanel/Message/EndPoints"
import notificationEndPoints from "apps/CustomerPanel/Notification/EndPoints"
import { useQueryClient } from "react-query";

const CustomerPanelIndex = () => {
  const queryClient = useQueryClient()
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const { adType,adData } = useSelector((state: RootState) => state.ad);
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("adManagement");
  const [searchParam] = useSearchParams();
  const dispatch = useDispatch()



  useEffect(() => {
    const activePanelMenu = searchParam.get("activePanelMenu");
    //pps' basınca boş geliyordu ya userType a göre header da hiç göstermeyelim yada ben burada profile atadım

    if (activePanelMenu) {
      setActiveMenu(activePanelMenu);
      // if(userInfoes?.userType ===1){
      //   setActiveMenu("profile");
      // }
      
    }
  }, [searchParam]);
  const filterMenuItemsByUserType = (userType: number) => {
    let menuItems = [
      {
        key: "adManagement",
        label: "İlan Oluştur",
        children: <StepsIndex />,
        icon: <FormOutlined/>,
      },
    ];
  
  
    if (userType === 1) {
      menuItems.push(
        {
          key: "myAdverts",
          label: "İlanlarım",
          children: <PortfolioIndex  isMLS={false} />,
          icon: <PicLeftOutlined />,
        },
        {
          key: "invitationList",
          label: "Davet Listesi",
          children: <InvitesIndex />,
          icon: <LikeOutlined />,
        },
        {
          key: "invoice",
          label: "Faturalar",
          children: <InvoiceIndex />,
          icon: <FilePdfOutlined />,
        },
        {
          key: "favorite",
          label: "Favori",
          children: <FavoriteIndex />,
          icon: <HeartOutlined />,
        },
        {
          key: "messages",
          label: "Mesaj",
          children: <MessageIndex />,
          icon: <MessageOutlined />,
        },
        {
          key: "notification",
          label: "Bildirim",
          children: <NotificationIndex />,
          icon: <NotificationOutlined />,
        },
        {
          key: "alarm",
          label: "Alarm",
          children: <AlarmIndex />,
          icon: <DashboardOutlined />,
        },
        {
          key: "profile",
          label: "Profil",
          children: <ProfileIndex />,
          icon: <UserOutlined />,
        },
      
      );
    } else if (userType === 2) {
      menuItems.push(
        {
          key: "myAdverts",
          label: "İlanlarım",
          children: <PortfolioIndex  isMLS={false} />,
          icon: <PicLeftOutlined />,
        },
       
        {
          key: "shoppingCenter",
          label: "Mağaza Yönetimi",
          children: <StoreIndex />,
          icon: <ShopOutlined />,
        },
        {
          key: "userManagement",
          label: "Kullanıcı Yönetimi",
          children: <UserManagementIndex />,
          icon: <UserOutlined />,
        },
        {
          key: "contract",
          label: "Sözleşme Yönetimi",
          children: <ContractIndex />,
          icon: <ContactsOutlined />,
        },
        {
          key: "pps",
          label: "PPS Portföy Paylaşım Sistemi",
          children: <MLSIndex />,
          icon: <EditOutlined />,
        },
        {
          key: "invoice",
          label: "Faturalar",
          children: <InvoiceIndex />,
          icon: <FilePdfOutlined />,
        },
        {
          key: "favorite",
          label: "Favori",
          children: <FavoriteIndex />,
          icon: <HeartOutlined />,
        },
        {
          key: "messages",
          label: "Mesaj",
          children: <MessageIndex />,
          icon: <MessageOutlined />,
        },
        {
          key: "notification",
          label: "Bildirim",
          children: <NotificationIndex />,
          icon: <NotificationOutlined />,
        },
        {
          key: "alarm",
          label: "Alarm",
          children: <AlarmIndex />,
          icon: <DashboardOutlined />,
        },
        {
          key: "profile",
          label: "Profil",
          children: <ProfileIndex />,
          icon: <UserOutlined />,
        },
        {
          key: "report",
          label: "Rapor",
          children: <ReportIndex />,
          icon: <AreaChartOutlined />,
        }
      );
    } else if (userType === 3) {
      menuItems.push(
        {
          key: "myAdverts",
          label: "İlanlarım",
          children: <PortfolioIndex isMLS={false} />,
          icon: <PicLeftOutlined />,
        },
        {
          key: "pps",
          label: "PPS Portföy Paylaşım Sistemi",
          children: <MLSIndex />,
          icon: <EditOutlined />,
        },
        {
          key: "invitationList",
          label: "Davet Listesi",
          children: <InvitesIndex />,
          icon: <LikeOutlined />,
        },
        {
          key: "favorite",
          label: "Favori",
          children: <FavoriteIndex />,
          icon: <HeartOutlined />,
        },
        {
          key: "messages",
          label: "Mesaj",
          children: <MessageIndex />,
          icon: <MessageOutlined />,
        },
        {
          key: "notification",
          label: "Bildirim",
          children: <NotificationIndex />,
          icon: <NotificationOutlined />,
        },
        {
          key: "profile",
          label: "Profil",
          children: <ProfileIndex />,
          icon: <UserOutlined />,
        }
      );
    }
  
    return menuItems;
  };
  

  const items = useMemo(() => {
    const userType = userInfoes?.userType || 1; // Varsayılan olarak 1
    return filterMenuItemsByUserType(userType);
  }, [userInfoes?.userType]);

  useEffect(()=>{
    if(activeMenu==="myAdverts")
    {
      queryClient.resetQueries({
        queryKey: myAdvertEndPoints.getUserAdvertList,
        exact: false,
      });
    }
    else if(activeMenu==="invitationList")
      {
        queryClient.resetQueries({
          queryKey: inviteEndPoints.getInviteListFilter,
          exact: false,
        });
      }
      else if(activeMenu==="messages")
        {
          queryClient.resetQueries({
            queryKey: messageEndPoints.getMessageGroupList,
            exact: false,
          });
        }
        else if(activeMenu==="notification")
          {
            queryClient.resetQueries({
              queryKey: notificationEndPoints.getNotificationList,
              exact: false,
            });
          }

  },[activeMenu])

  return (
    <>
    

    {
      userInfoes?<>
      
    <Col span={24}>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Tabs
        
            activeKey={activeMenu}
            onChange={(activeKey) => {
              navigate(`/admin/panel?activePanelMenu=${activeKey}`);
              setActiveMenu(activeKey);
              if(adType ||adData)
              {
                dispatch(handleResetAllAdvertState())
              }
            }}
            defaultActiveKey="adManagement"
            items={items}
          />
        </Col>
      </Row>
    </Col>
      </>:<>
      <Navigate to={"/"} />
      
      </>
    }
    </>
  );
};

export default CustomerPanelIndex;